console.log("mini-cart.js");
  $(function(){
    var miniCartInited = false;
  	var processCheckOut = false;
  	var processUpdateCart = false;
    
    function update(next){
      if(!processUpdateCart){
        
        /* not used in this theme
        
        processUpdateCart = true;
        
        var isUpdateRequired = false;
        var postObject = {"updates":[]};

        if($("#cartform").find("input.cart-qty").length>0){
          isUpdateRequired = true;
          $("#cartform").find("input.cart-qty").each(function(index,element){
            postObject.updates.push(+$(element).val());
          });
        }
        
        postObject.note= $("#note").val();

        if(isUpdateRequired){
          jQuery.post('/cart/update.js', postObject)
          .done(function(res){
            if(next){
              next();
            }
            else{
              location.reload();
            }
          })
          .catch(function(err){
            alert("Something is wrong.. Please empty cart and retry");
            location.reload();
          });
        }
        
        */
        next();
      
      }
    }
    
    function checkoutAndSubmit($button){
      if(!processCheckOut){
        processCheckOut = true;

        var isUpdateRequired = false;
        var postObject = {"updates":{}};

        window.IMTK.shopify.cart.items.forEach(function(item){
          if(item.properties && item.properties._variantIds){
          	isUpdateRequired = true;
            
            var variantIds = item.properties._variantIds.split(",");
            variantIds.forEach(function(variantId){
              if(postObject.updates[+variantId]){
                postObject.updates[+variantId] += item.quantity;
              }else{
                postObject.updates[+variantId] = item.quantity;
              }
            });
          }
        });
        console.log("checkout btn: ", $button);

        if(isUpdateRequired){
          jQuery.post('/cart/update.js', postObject)
          .done(function(res){
            $("#cartform").find("input.cart-qty").attr("disabled","disabled");
            $button.trigger("click");
          })
          .catch(function(err){
            alert("Something is wrong.. Please empty cart and retry");
            location.reload();
          });
        } else {
          $button.trigger("click");
        }

      }
    }
    
    function initTotalPrice(){
      var totalPrice = 0;
      $(".header [data-price-mini-cart]").each(function(index,element){
        totalPrice += (+$(element).data("priceMiniCart"));
      });
      $(".total_price_mini_cart").html("$ " + (totalPrice/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
    }
    
    /* not needed in mini-cart
    
    function initAdditionalCheckOutButtons(){
      var $targetButtons = $(".additional-checkout-buttons button[type='submit']");
      var $clonedButtons = $targetButtons.clone();
      
      $targetButtons.hide();
      $clonedButtons.each(function(index,element){
      	$(element).attr("type","button");
        $(element).attr("id",$(element).attr("id")+"_cloned");
      });
      $clonedButtons.appendTo( ".additional-checkout-buttons" );
      
      $clonedButtons.on("click",function(){
        var targetId = this.id.replace("_cloned","")
        var $target = $("#"+targetId);
      	update(function(){checkoutAndSubmit($target)});
      });
    }
    
    */  
    
    function init(){
      initTotalPrice();
      //initAdditionalCheckOutButtons();
            
      //mini-cart blocking item quantity change and redirect to cart
      $(function(){
        $("header .product-quantity-box").wrap('<a href="/cart" style="position:relative;display:block;" class="floats"></a>');
        $("header .product-quantity-box").after('<div style="position:absolute; width:100%; height:100%;"></div>');
      });
    }
    
    $(".mini_cart.dropdown_link").on("click, mouseover",function(){
      if(!miniCartInited){
        miniCartInited = true;
        init();
        
        //console.log('$(".imtk_checkout_mini_cart") :', $(".imtk_checkout_mini_cart"));
        
        $(".imtk_checkout_mini_cart").on("click",function(){
          //console.log("checkout btn clicked");
          var self = this;
          update(function(){checkoutAndSubmit($(".checkout_mini_cart"))});
        });
      }
    });

    /* not used in this theme
    
    $(".cart-remove").on("click",function(){
      $(this).closest("tr").find("input.cart-qty").val(0);
      $('#imtk_update_cart').trigger("click");
    });
        
    $("#imtk_update_cart").on("click",function(){
      update();
    });
    
    $(".cart-qty").on("change",function(){
      var index = $(".cart-qty").index($(this));
      var value = $(this).val();
      window.IMTK.shopify.cart.items[index].quantity = +value;
    });
    
    */
    
  });